import * as React from "react";
import { cn } from "@/shadcn/lib/utils";

// playerdex · registry v1 · shadcn@4.21.0

const Skeleton = React.forwardRef(function Skeleton(
  { className, ...props },
  ref
) {
  return (
    <div
      data-slot="skeleton"
      className={cn("bg-muted rounded-2xl animate-pulse", className)}
      ref={ref}
      {...props}
    />
  );
});

export { Skeleton };
